import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ScrollDown from './ScrollDown';
import { isFullyScrolled } from './scroll';
import { steppers, TAX_INFORMATION } from './helpers';
import { steppers as specializedStepper } from '../onboarding_generic/data';

function Panel({
  children = null,
  currentStep,
  isClinicCounsellor,
  specialized,
}) {
  const [fullyScrolled, setFullyScrolled] = useState(false);

  useEffect(() => {
    setFullyScrolled(false);
  }, [currentStep]);

  const classNames = value => {
    let className = '';

    if (value < currentStep) {
      className = 'completed-step';
    } else if (value === currentStep) {
      className = 'current-step';
    }

    return className;
  };

  let newSteppers = specialized ? specializedStepper : steppers;

  if (isClinicCounsellor) {
    newSteppers = newSteppers.filter(step => step.value !== TAX_INFORMATION);
  }

  return (
    <div className="panel">
      {newSteppers.map(({ value, label }) => (
        <div
          className="side-stepper flex-center"
          key={value}
          style={{ top: `calc(10px + ${value * 60}px)` }}
        >
          <div className={`stepper-circle flex-center ${classNames(value)}`}>
            {value + 1}
          </div>
          <div className={`stepper-label ${classNames(value)}`}>{label}</div>
        </div>
      ))}
      <div
        id="panel-content"
        className="panel-content"
        onScroll={() => isFullyScrolled(setFullyScrolled)}
      >
        {children}
      </div>
      {!fullyScrolled && <ScrollDown />}
    </div>
  );
}

Panel.propTypes = {
  children: PropTypes.node,
  currentStep: PropTypes.number.isRequired,
  isClinicCounsellor: PropTypes.bool,
};

export default Panel;
